import { Button, Flex, HStack, Text } from '@chakra-ui/react'
import { LuTriangleAlert } from 'react-icons/lu'
import { useTranslation } from '../../i18n'

// Claiming keeps running while a moderator browses the accepted/rejected views,
// so videos can pile up behind someone who has wandered off into the archive.
//
// Driven by how many videos *this* moderator is holding, not by the global
// queue: it should only interrupt when videos are actually stuck waiting on
// them, otherwise it would nag every moderator whenever the event got busy.

export function WaitingBanner({ count, onReturn }) {
  const { t } = useTranslation()
  if (count <= 0) return null

  return (
    <Flex
      align="center"
      justify="center"
      gap={4}
      px={4}
      py={2}
      flexShrink={0}
      bg="var(--landing-amarillo)"
      color="var(--landing-negro)"
    >
      <HStack gap={2}>
        <LuTriangleAlert />
        <Text fontSize="sm" fontWeight="700">
          {t('moderation.waitingBanner', { count })}
        </Text>
      </HStack>
      <Button size="xs" variant="solid" bg="var(--landing-negro)" color="var(--landing-amarillo)" onClick={onReturn}>
        {t('moderation.backToModeration')}
      </Button>
    </Flex>
  )
}
